import React, { useState, useEffect } from 'react'
import { BsChevronLeft } from 'react-icons/bs'
import { Helmet } from "react-helmet";
import { BsChevronRight } from 'react-icons/bs'
import StatusBadge from "../../js/buttonstatus.jsx";
import { Cookies } from "../../index.js";
import { RingLoader, BarLoader } from "react-spinners";
import axios from "axios";
import { alert_success } from '../../AppContext';
import OrdersReset from './orders_reset.jsx';


const ChangeHistory = () => {
    const [userOption, setUserOption] = useState("changeHistory");
    const [history, sethistory] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const totalPage = history ? Math.ceil(history.length / 10) : 1;
    const [pageStart, setPageStart] = useState(0)
    const [pageEnd, setPageEnd] = useState(10)
    const handleClick = (pageItem) => {
        setPageStart(0 + pageItem * 10)
        setPageEnd(10 + pageItem * 10)
    }
    const handleClickLeft = () => {
        if (pageStart >= 10) {
            setPageStart(pageStart - 10)
            setPageEnd(pageEnd - 10)
        }
    }
    const lichsudoithe = async () => {
        const apikey = Cookies.get("apikey");
        axios
            .get(
                "https://nginx.hust.media/go/otp/process/history?apikey=" + apikey
            )
            .then((response) => {
                console.log(response.data);
                sethistory(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleClickRight = () => {
        if (pageEnd <= history.length) {
            setPageStart(pageStart + 10)
            setPageEnd(pageEnd + 10)
        }
    }
    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);
    };
    function handleSelectReorder(item) {
        setSelectedOrder(item);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function handleReorderSuccess(info, latestHistory) {
        setSelectedOrder(null);
        if (Array.isArray(latestHistory)) {
            sethistory(latestHistory);
            return;
        }
        lichsudoithe();
    }
    let intervalId;
    function startLichSuDoiThe() {
        intervalId = setInterval(() => {
            lichsudoithe();
        }, 7000);
    }
    useEffect(() => {
        lichsudoithe();
        startLichSuDoiThe();

        return () => clearInterval(intervalId);
    }, []);
    return (
        <>
            <Helmet>
                <title>Nhật ký thuê sim</title>
                <meta name="description" content="Nhật ký đổi thẻ cào" />
            </Helmet>
            {(userOption === 'changeHistory' && history) ? (
                <div className='py-4 px-2 '>
                    <div className='bg-[#f5f6fa] rounded-md p-1'>
                        <div className='ml-2 border-blue-400 border-b inline'>Lịch sử thuê sim</div>
                        <OrdersReset
                            selectedOrder={selectedOrder}
                            onClose={() => setSelectedOrder(null)}
                            onSuccess={handleReorderSuccess}
                        />
                        <div className='overflow-x-scroll lg:overflow-auto '>
                            <table className='w-full table-fixed border-collapse'>
                                <thead>
                                    <tr className='text-xs lg:text-base border-b-2 text-center'>
                                        <th className='w-1/12 px-2'>Dịch vụ</th>
                                        <th className='w-1/12 px-2'>Số thuê</th>
                                        <th className='w-2/12 px-2'>Mã code</th>   {/* rộng gấp 3 */}
                                        <th className='w-1/12 px-2'>Note</th>
                                        <th className='w-1/12 px-2'>Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {history &&
                                        history.slice(pageStart, pageEnd).map((item, idx) => (
                                            <tr key={idx} className='text-xs border-b-2'>
                                                <td className='w-1/12 px-2 text-center'>{item.service_name}
                                                    <br /> <StatusBadge status={item.status} /><br />{item.type}
                                                </td>
                                                <td className='w-1/12 px-2 text-center text-break text-wrap'>
                                                    <button onClick={() => saochep(item.url)}>{item.url}</button>
                                                    <button onClick={() => handleSelectReorder(item)}><span className="border border-pink-300 rounded text-xs font-medium text-pink-700">
                                                        Thuê lại
                                                    </span></button>
                                                </td>
                                                <td className='w-2/12 px-2 text-center'>
                                                    {item.note}
                                                </td>
                                                <td className='w-1/12 px-2 text-center text-break text-wrap'><span className="border border-pink-300 rounded text-sm font-medium text-pink-700">
                                                    {item.money} Coins
                                                </span>
                                                    <br /> {item.order}</td>
                                                <td className='w-1/12 px-2 text-center'>
                                                    {item.createdate}<br />{item.updatedate}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>

                        </div>
                        <div className='flex mt-2 justify-center gap-2 flex-wrap'>
                            <div
                                className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer flex items-center text-xs lg:text-base'
                                onClick={() => handleClickLeft()}>
                                <BsChevronLeft />
                            </div>
                            {Array(totalPage)
                                .fill(0)
                                .map((_, index) => {
                                    const pageItem = index + 1
                                    return (
                                        <div
                                            className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer'
                                            onClick={() => handleClick(Number(index))}>
                                            {pageItem}
                                        </div>
                                    )
                                })}
                            <div
                                className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer flex items-center text-xs lg:text-base'
                                onClick={() => handleClickRight()}>
                                <BsChevronRight />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="mt-4 flex justify-center items-center">
                    <BarLoader size={50} color="#003AA5" />{" "}
                </div>
            )}
        </>
    )
}

export default ChangeHistory
